import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const DotsIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (

	<svg
		width="28"
		height="29"
		viewBox="0 0 28 29"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...rest}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.666 14.3206C11.666 13.032 12.7107 11.9873 13.9993 11.9873C15.288 11.9873 16.3327 13.032 16.3327 14.3206C16.3327 15.6093 15.288 16.654 13.9993 16.654C12.7107 16.654 11.666 15.6093 11.666 14.3206Z"
			fill={iconColor}/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.666 6.15365C11.666 4.86498 12.7107 3.82031 13.9993 3.82031C15.288 3.82031 16.3327 4.86498 16.3327 6.15365C16.3327 7.44231 15.288 8.48698 13.9993 8.48698C12.7107 8.48698 11.666 7.44231 11.666 6.15365Z"
			fill={iconColor}/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.666 22.4867C11.666 21.198 12.7107 20.1533 13.9993 20.1533C15.288 20.1533 16.3327 21.198 16.3327 22.4867C16.3327 23.7753 15.288 24.82 13.9993 24.82C12.7107 24.82 11.666 23.7753 11.666 22.4867Z"
			fill={iconColor}/>
	</svg>

);

export { DotsIcon };